export default "__VITE_ASSET__iVJ39SXz__"